export default "<div [innerHTML]=\"post.content\">\n</div>"